<template>
  <div>
    <div v-if="!address">
      Loading...
    </div>
    <div v-else>
      <div v-if=address.company>
        <data-merger :dict=address.company title="Company Name" />
      </div>
      <data-merger :dict=nameDictionary title="Customer Name" /><br>
      <a target=_blank :href="'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(streetAddress)">
        <data-merger :dict=address.street1 title="Street Line 1" /><br>
        <div v-if=address.street2>
          <data-merger :dict=address.street2 title="Street Line 2" />
        </div>
        <data-merger :dict=address.city title="City" />,
        <data-merger :dict=address.regionCode title="Region/State" />
        <data-merger :dict=address.zip title="ZIP Code" />
      </a><br>
      <data-merger :dict=address.country title="Country" :fuzzy="true" /><br />
      <data-merger :dict="address.phoneNumber" :show-warning="!isShipping" formatter=formatPhone title="Phone Number" />
    </div>
  </div>
</template>

<script>
import DataMerger from '../../utility/DataMerger.vue'
import orderMerger from '../../../services/orderMerge.js'

export default {
  props: {
    address: { type: Object, required: true },
    isShipping: { type: Boolean, required: true },
  },
  components: {
    DataMerger,
  },
  computed: {
    nameDictionary() {
      if (!this.address || !this.address.firstName) return {}
      const dict = {}

      if (this.address.firstName.fishbowl) {
        dict.fishbowl = `${this.address.firstName.fishbowl} ${this.address.lastName.fishbowl}`
      }

      const webName = Object.keys(this.address.firstName).filter(x => x !== 'fishbowl')[0];
      if (webName) {
        dict[webName] = `${this.address.firstName[webName]} ${this.address.lastName[webName]}`;
      }

      return dict;
    },
    streetAddress() {
      if (this.address) {
        return `${orderMerger.mergeField(this.address.street1)},
          ${orderMerger.mergeField(this.address.city)},
          ${orderMerger.mergeField(this.address.region)}
          ${orderMerger.mergeField(this.address.zip)}
          ${orderMerger.mergeField(this.address.country)}`.replace(/\s+/g, ' ')
      }
      return ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/AddressInfo.vue